// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import App from './App'
import router from './router'
import VueClipboard from 'vue-clipboard2'

import VueScroller from 'vue-scroller'
import './utils/rem.js'

Vue.config.productionTip = false

Vue.use(VueClipboard)
Vue.use(VueScroller)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js